import { authProvider as androidAuthProvider } from "./androidAuthProvider";
import { authProvider as browserAuthProvider } from "./browserAuthProvider";

export { AuthenticationState, apiTokenRequest, graphTokenRequest } from "./constants";
export const authProvider = androidAuthProvider ?? browserAuthProvider;
